"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _done = require("../../assets/icons/done.svg");
var _close = require("../../assets/icons/close.svg");
var _toggleModule = _interopRequireDefault(require("./toggle.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var Toggle = function Toggle(_ref) {
  var _classNames;
  var id = _ref.id,
    onChange = _ref.onChange,
    value = _ref.value,
    name = _ref.name,
    disabled = _ref.disabled,
    className = _ref.className,
    label = _ref.label;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var ref = (0, _react.useRef)(null);
  var handleChange = (0, _react.useCallback)(function (event) {
    onChange(event.currentTarget.checked, true);
  }, [onChange]);
  var handleClick = (0, _react.useCallback)(function (e) {
    if (!disabled) {
      // handle native checkbox click
      if (e.target !== ref.current) {
        e.preventDefault();
        ref.current.focus();
        ref.current.click();
      }
    }
  }, [disabled]);
  var handleFocus = (0, _react.useCallback)(function () {
    setFocused(true);
  }, []);
  var handleBlur = (0, _react.useCallback)(function () {
    setFocused(false);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_toggleModule.default['toggle'], className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, _toggleModule.default['toggle--focused'], focused), (0, _defineProperty2.default)(_classNames, _toggleModule.default['toggle--checked'], value), (0, _defineProperty2.default)(_classNames, _toggleModule.default['toggle--disabled'], disabled), _classNames)),
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _toggleModule.default['toggle__track']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _toggleModule.default['toggle__thumb']
  }, /*#__PURE__*/_react.default.createElement(_done.ReactComponent, {
    className: (0, _classnames.default)(_toggleModule.default['toggle__icon'], _toggleModule.default['toggle__checked-icon'])
  }), /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
    className: (0, _classnames.default)(_toggleModule.default['toggle__icon'], _toggleModule.default['toggle__unchecked-icon'])
  })), /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    id: id,
    checked: value,
    onFocus: handleFocus,
    onBlur: handleBlur,
    name: name,
    disabled: disabled,
    value: value.toString(),
    "data-testid": id,
    onChange: handleChange,
    className: _toggleModule.default['toggle__invisible-checkbox'],
    type: "checkbox"
  })), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: _toggleModule.default['toggle__label']
  }, label));
};
exports.Toggle = Toggle;